// Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// UI Imports
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Switch,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import Grid from "@material-ui/core/Grid/Grid";
import TextField from "@mui/material/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@mui/material/Button";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";

// Accordion
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
// import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@material-ui/core/Typography";

// Tabs
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

// ---- Datepicket UI Library imports
import dayjs from "dayjs";
import customFormat from "dayjs/plugin/customParseFormat";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo/DemoContainer";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

// App Imports
import { nullToEmptyString } from "../../../setup/helpers";
import { messageShow } from "../../common/api/actions";
import {
  detail,
  getAllCountryCodes,
  getAllCurrencies,
  getHolidayCollections,
} from "../api/actions/query";
import { getAllPincodes } from "../../pincode/api/actions/query";
import {
  save,
  updateSettings,
  createHolidayCollection,
  updateHolidayCollection,
  deleteHolidayCollection,
  bulkUpdateHolidayCollections,
} from "../api/actions/mutation";

import { encrption_secrey_key } from "../../../setup/config/env";
import timeZones from "../../../setup/config/timezone.json";
import { upload } from "../../common/api/actions";
import ImageComp from "../../common/Image";
import { getImageSource } from "../api/routes";
import { Container, Row, Col, Tabs } from "react-bootstrap";

import CryptoJS from "crypto-js";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment } from "@mui/material";
import { checkPermission } from "../../common/Sidebar/checkPermission";
import HolidayPlanner from "./HolidayPlanner";

// Component
class CreateOrUpdate extends Component {
  constructor(props) {
    super(props);
    dayjs.extend(customFormat);
    this.secretPass = encrption_secrey_key;
    this.settings = {
      _id: "",
      vendorId: "",
      phoneLine1: "",
      phoneLine2: "",
      whatsappNumber: "",
      paymentConfiguration: [
        {
          name: "SQUARE_PAY",
          isEnabled: false,
          config: [
            {
              type: "sandbox",
              accessKey: "",
              accessToken: "",
              locationId: "",
              isActive: false
            },
            { type: "production", accessKey: "", accessToken: "", locationId: "", isActive: false }
          ]
        },
        {
          name: "RAZOR_PAY",
          isEnabled: false,
          config: [
            { type: "sandbox", keyId: "", keySecret: "", isActive: false },
            { type: "production", keyId: "", keySecret: "", isActive: false }
          ]
        },
        {
          name: "STRIPE",
          isEnabled: false,
          config: [
            { type: "sandbox", stripePublishableKey: "", stripeSecretKey: "", isActive: false },
            { type: "production", stripePublishableKey: "", stripeSecretKey: "", isActive: false }
          ]
        }
      ],
      workingHours: [
        {
          day: "SUN",
          isHoliday: false,
          bStartTime: null,
          bEndTime: null,
          lStartTime: null,
          lEndTime: null,
        },
        {
          day: "MON",
          isHoliday: false,
          bStartTime: null,
          bEndTime: null,
          lStartTime: null,
          lEndTime: null,
        },
        {
          day: "TUE",
          isHoliday: false,
          bStartTime: null,
          bEndTime: null,
          lStartTime: null,
          lEndTime: null,
        },
        {
          day: "WED",
          isHoliday: false,
          bStartTime: null,
          bEndTime: null,
          lStartTime: null,
          lEndTime: null,
        },
        {
          day: "THU",
          isHoliday: false,
          bStartTime: null,
          bEndTime: null,
          lStartTime: null,
          lEndTime: null,
        },
        {
          day: "FRI",
          isHoliday: false,
          bStartTime: null,
          bEndTime: null,
          lStartTime: null,
          lEndTime: null,
        },
        {
          day: "SAT",
          isHoliday: false,
          bStartTime: null,
          bEndTime: null,
          lStartTime: null,
          lEndTime: null,
        },
      ],
      timeZone: "",
      taxAmount: "",
      onlinePricingPercentage: "",
      payAtStore: false,
      payOnline: false,
      cashOnDelivery: false,
      image: "",
      logo: "",
      countryCode: "",
      currency: "",
      charges: [],
      aboutUs: "",
      terms: "",
      privacyPolicy: "",
      faq: "",
      feedback: "",
      tableBooking: "",
      email: "",
      webAppUrl: "",
      qrDiningAppUrl: "",
      campaignUrl: "",
      iosAppUrl: "",
      androidAppUrl: "",
      facebook: "",
      website: "",
      instagram: "",
      facebook_app_id: "",
      youtube: "",
      linkedin: "",
      xapp: "",
      facebook_secret: "",
      facebook_access_token: "",
      facebook_page_id: "",
      isPickupAtStore: false,
      isHomeDelivery: false,
      infomsg1: "",
      infomsg2: "",
      infomsg3: "",
      isTaxAvailable: false,
      seoUrl: "",
      daisyToken: "",
      pickupAtStore: {
        paymentMethods: [],
        minimumCashAmount: 0,
        minimumOnlineAmount: 0,
      },

      homeDelivery: {
        deliveryType: [],
        minimumAmount: "",
        paymentMethods: [],
        milesSlabRates: []
      },
      uberSettings: {
        uberCustomerId: "",
        uberClientId: "",
        uberClientSecret: "",
      },
      isUberDeliveryEnabled: false,
      isOrderSmsEnabled: false,
      isAutoAcceptOrdersEnabled: false,
      isTableReservationSmsEnabled: false,
      Sms: {
        phoneNumber: ""
      },
      viewMode: '',
      isCalendarGoogleEnabled: false,
      isCalendarOutlookEnabled: false,
      orderNumbering: {
        prefix: 'ORD',
        nextNumber: 1,
        zeroPad: 5,
      },
    };

    this.state = {
      isLoading: false,
      isSubmitting: false,
      settings: this.settings,
      newCharge: {
        label: "",
        amount: "",
      },
      expanded: "panel1",
      tabValue: "1",
      gVal: null,
      countryCodes: [],
      currencies: [],
      pincodes: [],
      homeDeliveryPaymentMode: [],
      pickupPaymentMode: [],
      isUploadingFile: false,
      isUploadingFile2: false,
      showPassword: false,
      newSlab: {
        min: '',
        max: '',
        rate: ''
      },
      isSquarePay: this.settings?.paymentConfiguration?.find(pc => pc.name === "SQUARE_PAY")?.isEnabled ?? false,
      isRazorPay: this.settings?.paymentConfiguration?.find(pc => pc.name === "RAZOR_PAY")?.isEnabled ?? false,
      isStripe: this.settings?.paymentConfiguration?.find(pc => pc.name === "STRIPE").isEnabled ?? false,
      squarePayEnv: "sandbox",
      razorPayEnv: "sandbox",
      stripeEnv: "sandbox",
      permissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      },
      fullDayMap: {},
      roleName: '',
      holidays: []
    };
  }

  handleAccordion = (panel) => {
    const value = this.state.expanded === panel ? false : panel;
    this.setState({ expanded: value });
  };

  handleTabs = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  async componentDidMount() {
    this.refresh();
    this.fetchCountryCodes();
    this.fetchCurrencies();
    this.fetchPincodes();
    this.verifyPermissions();
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    this.setState({
      roleName: userData?.roleDetails?.name || "",
    });
  }

  verifyPermissions = async () => {
    const modulePermissions = await checkPermission("utilities", "");
    this.setState({ permissions: { canView: modulePermissions.canView, canCreate: modulePermissions.canCreate, canEdit: modulePermissions.canEdit, canDelete: modulePermissions.canDelete } });
  }

  fetchCountryCodes = async () => {
    const { getAllCountryCodes } = this.props;
    try {
      const { data } = await getAllCountryCodes();
      if (data.success) {
        this.setState({ countryCodes: data.data });
      }
    } catch (error) {
      console.error("Error fetching country codes:", error);
    }
  };

  fetchCurrencies = async () => {
    const { getAllCurrencies } = this.props;
    try {
      const { data } = await getAllCurrencies();
      if (data.success) {
        this.setState({ currencies: data.data });
      }
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  };
  fetchPincodes = async () => {
    const { getAllPincodes } = this.props;
    try {
      const { data } = await getAllPincodes();
      if (data.success) {
        this.setState({ pincodes: data.data });
      }
    } catch (error) {
      console.error("Error fetching pincodes:", error);
    }
  };

  refresh = async () => {
    const { detail, messageShow } = this.props;

    this.isLoadingToggle(true);

    try {
      const {
        match: {
          params: { vendorId },
        },
      } = this.props;
      this.setState({
        settings: { vendorId },
      });
      const { data } = await detail({ vendorId });
      this.fetchHolidays(); // Fetch holidays independently
      if (data.success && data.data) {
        if (data.data.paymentConfiguration.length > 0) {
          for (let paymentConfig of data.data.paymentConfiguration) {
            if (paymentConfig > 0) {
              data.data.paymentConfiguration = data.data.paymentConfiguration.map(method => ({
                ...method,
                isEnabled: method.isEnabled ?? false
              }));
            }
            for (let config of paymentConfig.config) {
              try {
                if (config.accessToken) {
                  config.accessToken = await this.decryptData(
                    config.accessToken
                  );
                }
                if (config.accessKey) {
                  config.accessKey = await this.decryptData(config.accessKey);
                }
                if (config.locationId) {
                  config.locationId = await this.decryptData(config.locationId);
                }
                if (config.keyId) {
                  config.keyId = await this.decryptData(config.keyId);
                }
                if (config.keySecret) {
                  config.keySecret = await this.decryptData(config.keySecret);
                }
                if (config.stripePublishableKey) {
                  config.stripePublishableKey = await this.decryptData(config.stripePublishableKey);
                }
                if (config.stripeSecretKey) {
                  config.stripeSecretKey = await this.decryptData(config.stripeSecretKey);
                }
              } catch (decryptionError) {
                messageShow(
                  "Failed to decrypt payment configuration. Please try again."
                );
              }
            }
          }
        }
        if (data.data.uberSettings) {
          try {
            if (data.data.uberSettings.uberClientId) {
              data.data.uberSettings.uberClientId = await this.decryptData(
                data.data.uberSettings.uberClientId
              );
            }
            if (data.data.uberSettings.uberClientSecret) {
              data.data.uberSettings.uberClientSecret = await this.decryptData(
                data.data.uberSettings.uberClientSecret
              );
            }
            if (data.data.uberSettings.uberCustomerId) {
              data.data.uberSettings.uberCustomerId = await this.decryptData(
                data.data.uberSettings.uberCustomerId
              );
            }
            // console.log(data.data.uberSettings);
          } catch (decryptionError) {
            messageShow(
              "Failed to decrypt uber configuration. Please try again."
            );
          }
        }
        if (data.data?.workingHours?.length > 0) {
          const workHrs = data.data.workingHours?.map((eWorkHrs) => {
            for (let key in eWorkHrs) {
              if (eWorkHrs[key] && key.includes("Time")) {
                eWorkHrs[key] = dayjs(eWorkHrs[key].toString(), "HH:mm");
              }
            }
            return eWorkHrs;
          });
          data.data.workingHours = workHrs;
        } else {
          data.data.workingHours = this.settings.workingHours;
        }
        data.data.timeZone =
          data.data.timeZone !== undefined ? data.data.timeZone : "";

        // Ensure isHoliday is an array
        if (!data.data.isHoliday) {
          data.data.isHoliday = [];
        }

        const getActiveEnvType = (configArray) =>
          configArray?.find((cfg) => cfg.isActive)?.type || "sandbox";

        this.setState({
          settings: data.data,
          squarePayEnv: getActiveEnvType(
            data.data.paymentConfiguration.find((p) => p.name === "SQUARE_PAY")?.config
          ),
          razorPayEnv: getActiveEnvType(
            data.data.paymentConfiguration.find((p) => p.name === "RAZOR_PAY")?.config
          ),
          stripeEnv: getActiveEnvType(
            data.data.paymentConfiguration.find((p) => p.name === "STRIPE")?.config
          ),
          isSquarePay: data.data.paymentConfiguration?.find(p => p.name === "SQUARE_PAY")?.isEnabled ?? false,
          isRazorPay: data.data.paymentConfiguration?.find(p => p.name === "RAZOR_PAY")?.isEnabled ?? false,
          isStripe: data.data.paymentConfiguration?.find(p => p.name === "STRIPE")?.isEnabled ?? false,
        });
      }
    } catch (error) {
      console.error(error)
      messageShow("Some error occurred. Please try again.");
    } finally {
      this.isLoadingToggle(false);
    }
  };

  encryptData = async (value) => {
    const data = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      this.secretPass
    ).toString();
    return data;
  };

  decryptData = async (value) => {
    const bytes = CryptoJS.AES.decrypt(value, this.secretPass);
    const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return data;
  };

  // onSave method
  onSave = async (event) => {
    event.preventDefault();

    const { save, messageShow } = this.props;

    const { settings } = this.state;

    this.isSubmittingToggle(true);

    try {
      // Encrypt sensitive data

      for (let i = 0; i < settings.paymentConfiguration.length; i++) {
        let config = settings.paymentConfiguration[i].config;
        if (config.accessKey) {
          config.accessKey = await this.encryptData(config.accessKey);
        }
        if (config.accessToken) {
          config.accessToken = await this.encryptData(config.accessToken);
        }
        if (config.locationId) {
          config.locationId = await this.encryptData(config.locationId);
        }
      }
      const { data } = await save(settings);
      this.isSubmittingToggle(false);
      messageShow(data.message);
    } catch (error) {
      this.isSubmittingToggle(false);

      messageShow("Some error occurred. Please try again.");
    }
  };
  onUpload = async (event) => {
    const { upload, messageShow } = this.props;

    messageShow("Uploading file, please wait...");

    this.isUploadingFileToggle(true);

    let file = new FormData();
    file.append("type", "settings");
    file.append("name", "logo");
    file.append("file", event.target.files[0]);

    const fileReader = new FileReader();
    fileReader.onload = () => {
      const fileResult = fileReader.result;
      let dataAsImg = new Image();
      dataAsImg.src = fileResult;
      this.setState({ previewImage: dataAsImg.src });
    };
    fileReader.readAsDataURL(event.target.files[0]);

    // Upload image
    try {
      const { data } = await upload(file);

      if (data.success) {
        this.props.messageShow("File uploaded successfully.");

        const { settings } = this.state;

        setTimeout(() => {
          settings.image = data.file;
          this.setState({
            settings,
          });
        }, 1000);
      } else {
        messageShow("There was some error. Please try again.");
      }
    } catch (error) {
      messageShow("There was some error. Please try again.");
    } finally {
      this.isUploadingFileToggle(false);
    }
  };
  onUpload2 = async (event) => {
    const { upload, messageShow } = this.props;

    messageShow("Uploading file, please wait...");

    this.isUploadingFileToggle2(true);

    let file = new FormData();
    file.append("type", "settings");
    file.append("name", "default");
    file.append("file", event.target.files[0]);

    const fileReader = new FileReader();
    fileReader.onload = () => {
      const fileResult = fileReader.result;
      let dataAsImg = new Image();
      dataAsImg.src = fileResult;
      this.setState({ previewImage2: dataAsImg.src });
    };
    fileReader.readAsDataURL(event.target.files[0]);

    // Upload image
    try {
      const { data } = await upload(file);

      if (data.success) {
        this.props.messageShow("File uploaded successfully.");

        const { settings } = this.state;

        setTimeout(() => {
          settings.logo = data.file;
          this.setState({
            settings,
          });
        }, 1000);
      } else {
        messageShow("failed to upload image");
      }
    } catch (error) {
      messageShow("Error on uploading logo");
    } finally {
      this.isUploadingFileToggle2(false);
    }
  };

  isUploadingFileToggle = (isUploadingFile) => {
    this.setState({
      isUploadingFile,
    });
  };

  isUploadingFileToggle2 = (isUploadingFile2) => {
    this.setState({
      isUploadingFile2,
    });
  };

  isLoadingToggle = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  isSubmittingToggle = (isSubmitting) => {
    this.setState({
      isSubmitting,
    });
  };

  onChange = ({ target: { name, value } }) => {
    const { settings } = this.state;
    settings[name] = value;
    this.setState({
      settings,
    });
  };

  handlePaymentMethodToggle = (e, methodName) => {
    const { checked } = e.target;
    const providerMap = {
      isSquarePay: "SQUARE_PAY",
      isRazorPay: "RAZOR_PAY",
      isStripe: "STRIPE"
    };

    const providerName = providerMap[methodName];
    const { settings } = this.state;

    let updatedPaymentConfig = [...settings.paymentConfiguration];

    updatedPaymentConfig = updatedPaymentConfig.map((payment) => {
      if (payment.name === providerName) {
        return {
          ...payment,
          isEnabled: checked
        };
      }
      return payment;
    });

    this.setState({
      settings: {
        ...settings,
        paymentConfiguration: updatedPaymentConfig
      },
      [methodName]: checked,
    });
  };

  handleEnvChange = (providerName, env) => {
    this.setState((prevState) => {
      const newSettings = { ...prevState.settings };
      const configIndex = newSettings.paymentConfiguration.findIndex(p => p.name === providerName);
      if (configIndex !== -1) {
        newSettings.paymentConfiguration[configIndex].config = newSettings.paymentConfiguration[configIndex].config.map(cfg => ({
          ...cfg,
          isActive: cfg.type === env
        }));
      }
      const tabKeyMap = {
        SQUARE_PAY: 'squareTabValue',
        RAZOR_PAY: 'razorpayTabValue',
        STRIPE: 'stripeTabValue'
      };

      const envKeyMap = {
        SQUARE_PAY: "squarePayEnv",
        RAZOR_PAY: "razorPayEnv",
        STRIPE: "stripeEnv",
      };

      return {
        settings: newSettings,
        [envKeyMap[providerName]]: env,
        [tabKeyMap[providerName]]: env
      };
    });
  };

  onChangesandbox = (event) => {
    const { name, value } = event.target;
    const { settings } = this.state;
    this.setState({
      settings: {
        ...settings,
        sandbox: {
          ...settings.sandbox,
          [name]: value,
        },
      },
    });
  };

  onChangeproduction = (event) => {
    const { name, value } = event.target;
    const { settings } = this.state;
    this.setState({
      settings: {
        ...settings,
        production: {
          ...settings.production,
          [name]: value,
        },
      },
    });
  };

  onChangePaymentMethod = (value) => {
    const { settings } = this.state;
    const updatedPaymentConfigurations = settings.paymentConfiguration.map(
      (configGroup) => ({
        ...configGroup,
        config: configGroup.config.map((config) => ({
          ...config,
          isActive: config.type === value,
        })),
      })
    );

    this.setState({
      settings: {
        ...settings,
        paymentConfiguration: updatedPaymentConfigurations,
      },
    });
  };

  onPaymentConfigChange = (e, providerName, envIndex) => {
    const { name, value } = e.target;
    const { settings } = this.state;
    const nameParts = name.split("_");
    const newSettings = JSON.parse(JSON.stringify(settings));
    if (!Array.isArray(newSettings.paymentConfiguration)) {
      newSettings.paymentConfiguration = [];
    }
    let providerIndex = newSettings.paymentConfiguration.findIndex(
      (pc) => pc.name === providerName
    );

    if (providerIndex === -1) {
      const defaultConfigs = {
        SQUARE_PAY: [
          { type: "sandbox", accessKey: "", accessToken: "", locationId: "", isActive: true },
          { type: "production", accessKey: "", accessToken: "", locationId: "", isActive: false },
        ],
        RAZOR_PAY: [
          { type: "sandbox", keyId: "", keySecret: "", isActive: true },
          { type: "production", keyId: "", keySecret: "", isActive: false },
        ],
        STRIPE: [
          { type: "sandbox", stripePublishableKey: "", stripeSecretKey: "", isActive: true },
          { type: "production", stripePublishableKey: "", stripeSecretKey: "", isActive: false },
        ],
      };

      newSettings.paymentConfiguration.push({
        name: providerName,
        config: defaultConfigs[providerName] || [],
      });

      providerIndex = newSettings.paymentConfiguration.length - 1;
    }

    const providerConfig = newSettings.paymentConfiguration[providerIndex];
    if (!Array.isArray(providerConfig.config)) {
      providerConfig.config = [];
    }

    if (!providerConfig.config[envIndex]) {
      const defaultConfigEntry = {
        type: envIndex === 0 ? "sandbox" : "production",
        isActive: envIndex === 0,
      };
      providerConfig.config[envIndex] = defaultConfigEntry;
    }

    providerConfig.config[envIndex][name] = value;
    providerConfig.config = providerConfig.config.map((cfg, index) => ({
      ...cfg,
      isActive: index === envIndex,
    }));

    this.setState({
      settings: newSettings,
    });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  onChangeHomeDelivery = (event) => {
    const { name, value } = event.target;

    if (/[a-zA-Z]/.test(value)) {
      alert("Please Enter Only Number !!");
      return;
    }
    this.setState({
      settings: {
        ...this.state.settings,
        homeDelivery: {
          ...this.state.settings.homeDelivery,
          [name]: value,
        },
      },
    });
  };

  handleAddSlab = () => {
    const { min, max, rate } = this.state.newSlab;
    const newMin = parseFloat(min);
    const newMax = parseFloat(max);
    const newRate = parseFloat(rate);
    const editIndex = this.state.editIndex;

    if (newMin >= newMax) {
      alert("Min distance must be less than Max distance.");
      return;
    }

    const newSettings = { ...this.state.settings };
    if (!Array.isArray(newSettings.homeDelivery.milesSlabRates)) {
      newSettings.homeDelivery.milesSlabRates = [];
    }

    const slabs = newSettings.homeDelivery.milesSlabRates || [];

    const overlaps = slabs.some((slab, index) => {
      if (editIndex !== undefined && index === editIndex) {
        return false;
      }
      return newMin < slab.max && newMax > slab.min;
    });

    if (overlaps) {
      alert("This slab overlaps with an existing range. Please choose a non-overlapping range.");
      return;
    }

    if (editIndex !== undefined) {
      slabs[editIndex] = { min: newMin, max: newMax, rate: newRate };
    } else {
      slabs.push({ min: newMin, max: newMax, rate: newRate });
    }

    slabs.sort((a, b) => a.min - b.min);
    newSettings.homeDelivery.milesSlabRates = slabs;

    this.setState({
      settings: newSettings,
      newSlab: { min: '', max: '', rate: '' },
      editIndex: undefined,
    });
  };

  handleEditSlab = (index) => {
    const slab = this.state.settings.homeDelivery.milesSlabRates[index];
    this.setState({
      newSlab: {
        min: slab.min,
        max: slab.max,
        rate: slab.rate,
      },
      editIndex: index,
    });
  };

  fetchHolidays = async () => {
    const { getHolidayCollections } = this.props;
    const { settings } = this.state;
    const vendorId = settings.vendorId || this.props.match.params.vendorId;
    if (!vendorId) return;

    try {
      const { data } = await getHolidayCollections({ vendorId });
      if (data.success) {
        this.setState({ holidays: data.data });

        // Migration Check
        if (data.data.length === 0 && settings.isHoliday && settings.isHoliday.length > 0) {
          const shouldMigrate = window.confirm("Legacy holidays detected. Do you want to migrate them to the new Holiday system? This is recommended.");
          if (shouldMigrate) {
            this.handleMigrateHolidays();
          }
        }
      }
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };



  handleCreateHolidayCollection = async (params) => {
    const { createHolidayCollection, messageShow, match } = this.props;
    const { settings } = this.state;
    const vendorId = settings.vendorId || match.params.vendorId;

    try {
      this.isLoadingToggle(true);
      const { data } = await createHolidayCollection({ ...params, vendorId });
      this.isLoadingToggle(false);
      if (data.success) {
        messageShow("Collection created.");
        // Optimized: Update state directly instead of fetching
        this.setState(prevState => ({
          holidays: [...prevState.holidays, data.data]
        }));
        return data;
      } else {
        messageShow(data.message || "Error creating collection.");
      }
    } catch (error) {
      console.error("Create Collection Error:", error);
      this.isLoadingToggle(false);
      messageShow(error.message || "Error creating collection.");
    }
  };

  handleUpdateHolidayCollection = async (params) => {
    const { updateHolidayCollection, messageShow } = this.props;
    try {
      const { data } = await updateHolidayCollection(params);
      if (data.success) {
        // Update state directly instead of fetching
        this.setState(prevState => ({
          holidays: prevState.holidays.map(col =>
            col._id === data.data._id ? data.data : col
          )
        }));
      } else {
        messageShow(data.message || "Error updating collection.");
      }
    } catch (error) {
      console.error(error);
      messageShow("Error updating collection.");
    }
  };

  handleDeleteHolidayCollection = async (params) => {
    const { deleteHolidayCollection, messageShow } = this.props;
    try {
      this.isLoadingToggle(true);
      const { data } = await deleteHolidayCollection(params);
      this.isLoadingToggle(false);
      if (data.success) {
        messageShow("Collection deleted.");
        //  Update state directly instead of fetching
        this.setState(prevState => ({
          holidays: prevState.holidays.map(col => col._id === data.data._id ? data.data : col)
        }));
      } else {
        messageShow(data.message || "Error deleting collection.");
      }
    } catch (error) {
      this.isLoadingToggle(false);
      messageShow("Error deleting collection.");
    }
  };

  handleBulkUpdateHolidayCollections = async (params) => {
    const { bulkUpdateHolidayCollections, messageShow } = this.props;
    try {
      this.isLoadingToggle(true);
      const { vendorId } = this.state.settings;
      const { data } = await bulkUpdateHolidayCollections({ ...params, vendorId });
      this.isLoadingToggle(false);

      if (data && data.data && data.data.results) {
        this.fetchHolidays();
        return data.data;
      } else {
        messageShow(data.message || "Bulk update failed");
      }
    } catch (error) {
      console.error("Bulk Update Error:", error);
      this.isLoadingToggle(false);
      messageShow(error.message || "Error bulk updating.");
    }
  };

  handleDeleteSlab = (index) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this slab?");
    if (confirmDelete) {
      const newSettings = { ...this.state.settings };
      newSettings.homeDelivery.milesSlabRates.splice(index, 1);
      this.setState({
        settings: newSettings,
      });
    }
  };


  onChangePickup = (event) => {
    const { settings } = this.state;
    const { value } = event.target;
    const isPayAtStoreSelected = value.includes("PAY_AT_STORE");
    const isPayOnlineSelected = value.includes("PAY_ONLINE") || value.includes("WEB_ONLY_PAY_ONLINE");
    this.setState({
      settings: {
        ...settings,
        pickupAtStore: {
          ...settings.pickupAtStore,
          paymentMethods: value,
          minimumCashAmount: isPayAtStoreSelected ? settings.pickupAtStore.minimumCashAmount : "",
          minimumOnlineAmount: isPayOnlineSelected ? settings.pickupAtStore.minimumOnlineAmount : "",
        },
      },
    });
  };
  onChangeMinimumCashAmount = (event) => {
    const { value } = event.target;
    this.setState((prevState) => ({
      settings: {
        ...prevState.settings,
        pickupAtStore: {
          ...prevState.settings.pickupAtStore,
          minimumCashAmount: value,
        },
      },
    }));
  };
  onChangeMinimumOnlineAmount = (event) => {
    const { value } = event.target;
    this.setState((prevState) => ({
      settings: {
        ...prevState.settings,
        pickupAtStore: {
          ...prevState.settings.pickupAtStore,
          minimumOnlineAmount: value,
        },
      },
    }));
  };

  onChangeSelfHomeDelivery = (event) => {
    const { settings } = this.state;
    const { value } = event.target;
    this.setState({
      settings: {
        ...settings,
        homeDelivery: {
          ...settings.homeDelivery,
          paymentMethods: value,
        },
      },
    });
  };

  onChangePincode = (e) => {
    const { value } = e.target;
    this.setState((prevState) => ({
      settings: {
        ...prevState.settings,
        homeDelivery: {
          ...prevState.settings.homeDelivery,
          deliveryPincodes: value !== null ? value : [],
        },
      },
    }));
  };

  onChangedeliverytype = (e) => {
    const { value } = e.target;
    this.setState((prevState) => ({
      settings: {
        ...prevState.settings,
        homeDelivery: {
          ...prevState.settings.homeDelivery,
          deliveryType: typeof value === "string" ? value.split(',') : value,
        },
      },
    }));
  };

  onChangeisPickupAtStore = (event) => {
    const { checked } = event.target;
    this.setState((prevState) => {
      let updatedSettings = { ...prevState.settings };
      if (!checked) {
        // Clear data related to Pickup At Store when unchecked
        updatedSettings.isPickupAtStore = false;
        updatedSettings.pickupAtStore = {
          paymentMethods: [],
        };
      } else {
        updatedSettings.isPickupAtStore = true;
      }
      return { settings: updatedSettings };
    });
  };
  onChangeisHomeDeliveryy = (event) => {
    const { checked } = event.target;
    this.setState((prevState) => {
      let updatedSettings = { ...prevState.settings };
      if (!checked) {
        // Clear data related to Pickup At Store when unchecked
        updatedSettings.isHomeDelivery = false;
        updatedSettings.homeDelivery = {
          deliveryType: "",
          minimumAmount: "",
          paymentMethods: [],
        };
      } else {
        updatedSettings.isHomeDelivery = true;
      }
      return { settings: updatedSettings };
    });
  };

  onChangeisSmsEnabled = (event) => {
    const { name, checked } = event.target;
    this.setState((prevState) => {
      const updatedSettings = { ...prevState.settings };

      updatedSettings[name] = checked;

      updatedSettings.isSmsEnabled = updatedSettings.isOrderSmsEnabled || updatedSettings.isTableReservationSmsEnabled;

      if (!updatedSettings.isSmsEnabled) {
        updatedSettings.Sms.phoneNumber = '';
      }

      return { settings: updatedSettings };
    });
  };


  getSelectedCountryCode = () => {
    const { countryCodes } = this.state;
    const selectedId = this.state.settings.countryCode;
    const selected = countryCodes.find(c => c._id === selectedId);
    return selected?.code || '';
  };

  onChangePhoneNumber = (event) => {
    const numberOnly = event.target.value.replace(/[^0-9]/g, '');
    const code = this.getSelectedCountryCode();
    const fullPhone = code + numberOnly;

    this.setState((prevState) => ({
      settings: {
        ...prevState.settings,
        Sms: {
          ...prevState.settings.Sms,
          phoneNumber: fullPhone
        },
      },
    }));
  };

  onChangeCountryCode = (event) => {
    const { settings } = this.state;
    settings.countryCode = event.target.value;
    this.setState({
      settings,
    });
  };

  onChangeCurrency = (event) => {
    const { settings } = this.state;
    settings.currency = event.target.value;
    this.setState({
      settings,
    });
  };

  onChangeTime = (newVal, mode, day, isHoliday) => {
    const workingHours = [...this.state.settings.workingHours].map((mWhrs) => {
      if (mWhrs.day === day) {
        mWhrs[mode] = newVal ? dayjs(newVal).format() : null;
        if (isHoliday !== undefined) mWhrs.isHoliday = isHoliday;
      }
      return mWhrs;
    });
    const settings = { ...this.state.settings, workingHours: workingHours };
    this.setState({ settings: settings });
  };

  setFullDayTiming = (checked, day) => {
    const updatedSettings = { ...this.state.settings };

    updatedSettings.workingHours = updatedSettings.workingHours.map((item) => {
      if (item.day === day) {
        if (checked) {
          item.bStartTime = dayjs("00:00", "HH:mm");
          item.bEndTime = dayjs("12:00", "HH:mm");
          item.lStartTime = dayjs("12:00", "HH:mm");
          item.lEndTime = dayjs("23:59", "HH:mm");
        } else {
          item.bStartTime = null;
          item.bEndTime = null;
          item.lStartTime = null;
          item.lEndTime = null;
        }
      }
      return item;
    });

    this.setState({ settings: updatedSettings });
  };

  resetTime = (day, resetSlot) => {
    // 'morn', 'noon', 'eve'
    const workingHours = [...this.state.settings.workingHours].map((mWhrs) => {
      if (mWhrs.day === day) {
        if (resetSlot === "morn") {
          mWhrs.bStartTime = null;
          mWhrs.bEndTime = null;
        } else {
          mWhrs.lStartTime = null;
          mWhrs.lEndTime = null;
        }
      }
      return mWhrs;
    });
    const settings = { ...this.state.settings, workingHours: workingHours };
    this.setState({ settings: settings });
  };

  appConfigChange = (type, value) => {
    const key = type === "tax" ? "taxAmount" : "timeZone";
    const settings = { ...this.state.settings, [key]: value };
    this.setState({ settings: settings });
  };

  taxChargeChange = (key, value) => {
    const settings = { ...this.state.settings, [key]: value };
    if (parseFloat(value) > 0) {
      settings.isTaxAvailable = true;
    } else {
      settings.isTaxAvailable = false;
    }
    this.setState({ settings: settings });
  };

  newChargeChange = (key, value) => {
    const newCharge = { ...this.state.newCharge, [key]: value };
    this.setState({ newCharge: newCharge });
  };

  addNewCharge = () => {
    const { settings, newCharge } = this.state;
    const charges = settings?.charges || [];
    charges.push(newCharge);
    this.setState({ newCharge: { label: "", amount: "" } });
    const updatedSettings = { ...settings, charges: charges };
    this.setState({ settings: updatedSettings });
  };

  removeCharge = (index) => {
    const { settings } = this.state;
    const updatedCharges = [...settings.charges];
    updatedCharges.splice(index, 1);
    const updatedSettings = { ...settings, charges: updatedCharges };
    this.setState({ settings: updatedSettings });
  };

  // Uber Settings change
  uberSettingsChange = (key, value) => {
    const settings = {
      ...this.state.settings,
      uberSettings: { ...this.state.settings.uberSettings, [key]: value },
    };
    this.setState({ settings: settings });
  };

  // Save App Configuration
  saveAppConfig = () => {
    const {
      timeZone,
      countryCode,
      aboutUs,
      terms,
      privacyPolicy,
      faq,
      feedback,
      tableBooking,
      email,
      webAppUrl,
      qrDiningAppUrl,
      campaignUrl,
      invoicesUrl,
      iosAppUrl,
      androidAppUrl,
      onlinePricingPercentage,
      image,
      logo,
      seoUrl,
      daisyToken
    } = this.state.settings;
    this.modifySettings({
      timeZone,
      countryCode,
      aboutUs,
      terms,
      privacyPolicy,
      faq,
      feedback,
      tableBooking,
      email,
      webAppUrl,
      qrDiningAppUrl,
      campaignUrl,
      invoicesUrl,
      iosAppUrl,
      androidAppUrl,
      onlinePricingPercentage,
      image,
      logo,
      seoUrl,
      daisyToken
    });
  };
  saveDeliverySetup = () => {
    const { settings } = this.state;
    if (!(settings.isPickupAtStore || settings.isHomeDelivery)) {
      alert("Please select atleast 1 delivery type  !!");
      return;
    }
    const {
      isPickupAtStore,
      isHomeDelivery,
      infomsg1,
      infomsg2,
      infomsg3,
      pickupAtStore,
      homeDelivery,
      orderNumbering,
    } = this.state.settings;

    if (orderNumbering) {
      if (!orderNumbering.prefix || orderNumbering.prefix.trim() === '') {
        this.props.messageShow('Order prefix is required.');
        return;
      }
      const nextNum = parseInt(orderNumbering.nextNumber, 10);
      if (isNaN(nextNum) || nextNum < 1) {
        this.props.messageShow('Next order number must be at least 1.');
        return;
      }
      const zeroPad = parseInt(orderNumbering.zeroPad, 10);
      if (isNaN(zeroPad) || zeroPad < 1 || zeroPad > 10) {
        this.props.messageShow('Zero pad must be between 1 and 10.');
        return;
      }
    }

    this.modifySettings({
      isPickupAtStore,
      isHomeDelivery,
      infomsg1,
      infomsg2,
      infomsg3,
      pickupAtStore,
      homeDelivery,
      orderNumbering,
    });
  };
  
  onChangeAutoAcceptOrders = (event) => {
    const { checked } = event.target;
    this.setState((prevState) => ({
      settings: {
        ...prevState.settings,
        isAutoAcceptOrdersEnabled: checked,
      },
    }));
  };

  saveNotificationSetup = () => {
    const { settings } = this.state;
    const { messageShow } = this.props;
    const {
      isOrderSmsEnabled,
      isTableReservationSmsEnabled,
      isAutoAcceptOrdersEnabled,
      Sms,
    } = settings;
    const isSmsEnabled = isOrderSmsEnabled || isTableReservationSmsEnabled;
    const phoneNumber = Sms?.phoneNumber?.toString().trim();

    if (isSmsEnabled && !phoneNumber) {
      messageShow("Phone number is required when SMS is enabled.");
      return;
    }

    this.modifySettings({
      isOrderSmsEnabled,
      isTableReservationSmsEnabled,
      isAutoAcceptOrdersEnabled,
      Sms
    });
  };

  onChangeOrderNumbering = (key, value) => {
    this.setState((prevState) => ({
      settings: {
        ...prevState.settings,
        orderNumbering: {
          ...prevState.settings.orderNumbering,
          [key]: value,
        },
      },
    }));
  };

  saveUserpreferences = () => {
    const { viewMode } = this.state.settings;
    this.modifySettings({ viewMode });
  };

  saveTaxCharges = () => {
    const { taxAmount, currency, charges, isTaxAvailable } = this.state.settings;
    this.modifySettings({ taxAmount, currency, charges, isTaxAvailable });
  };

  // Save working Hours
  saveAppWorkingHours = () => {
    let workingHours = JSON.parse(
      JSON.stringify(this.state.settings.workingHours)
    );
    this.isSubmittingToggle(true);
    workingHours = workingHours.map((eWrkhrs) => {
      if (!eWrkhrs.isHoliday) {
        for (let key in eWrkhrs) {
          if (eWrkhrs[key] && key.includes("Time")) {
            eWrkhrs[key] = dayjs(eWrkhrs[key].toString()).format("HH:mm");
          }
        }
      }
      return eWrkhrs;
    });
    this.modifySettings({ workingHours: workingHours });
  };

  savePaymentConfig = async () => {
    const { phoneLine1, phoneLine2, paymentConfiguration } =
      this.state.settings;
    const { messageShow } = this.props;

    const enabledMethods = {};
    paymentConfiguration.forEach((method) => {
      enabledMethods[method.name] = method.isEnabled;
    });

    const displayNames = {
      SQUARE_PAY: "Square Pay",
      RAZOR_PAY: "Razor Pay",
      STRIPE: "Stripe",
    };

    const requiredFields = {
      SQUARE_PAY: ["accessKey", "accessToken", "locationId"],
      RAZOR_PAY: ["keyId", "keySecret"],
      STRIPE: ["stripePublishableKey", "stripeSecretKey"],
    };

    for (const [methodKey, isEnabled] of Object.entries(enabledMethods)) {
      if (isEnabled) {
        const methodConfig = paymentConfiguration.find((m) => m.name === methodKey);
        if (!methodConfig || !Array.isArray(methodConfig.config) || methodConfig.config.length === 0) {
          messageShow(`Configuration missing for enabled payment method: ${displayNames[methodKey]}`);
          return;
        }
      }
    }

    for (const method of paymentConfiguration) {
      const methodName = method.name;
      const isEnabled = enabledMethods[methodName];

      if (!isEnabled) continue;

      const activeConfig = method.config?.find((cfg) => cfg.isActive);
      if (!activeConfig) {
        messageShow(`Please select active environment for ${displayNames[methodName]}`);
        return;
      }

      const missingFields = requiredFields[methodName]?.filter(
        (field) => !activeConfig[field] || activeConfig[field].trim() === ""
      );

      if (missingFields?.length > 0) {
        messageShow(`Please fill in all the required fields for ${displayNames[methodName]}`);
        return;
      }
    }

    const encryptedConfig = JSON.parse(JSON.stringify(paymentConfiguration));

    // Process payment configuration to handle sensitive data
    const sensitiveFields = ["accessKey", "accessToken", "locationId", "keyId", "keySecret", "stripePublishableKey", "stripeSecretKey"];
    for (let i = 0; i < encryptedConfig.length; i++) {
      for (let j = 0; j < encryptedConfig[i].config.length; j++) {
        const config = encryptedConfig[i].config[j];
        for (const key in config) {
          if (sensitiveFields.includes(key) && config[key]) {
            const encryptedValue = await this.encryptData(config[key]);
            encryptedConfig[i].config[j][key] = encryptedValue;
          }
        }
      }
    }

    for (let i = 0; i < encryptedConfig.length; i++) {
      encryptedConfig[i].config = encryptedConfig[i].config.map(cfg => {
        const cleaned = { ...cfg };
        if (cleaned._id === "") {
          delete cleaned._id;
        }
        return cleaned;
      });
    }

    // Call modifySettings with the updated payment configuration
    this.modifySettings({
      phoneLine1,
      phoneLine2,
      paymentConfiguration: encryptedConfig,
    });
  };

  // Save Uber Settings
  saveUberSettings = async () => {
    const { uberSettings } = this.state.settings;
    const newUberSettings = JSON.parse(JSON.stringify(uberSettings));
    for (const key in newUberSettings) {
      if (newUberSettings[key]) {
        const encryptedValue = await this.encryptData(newUberSettings[key]);
        newUberSettings[key] = encryptedValue;
      }
    }
    this.modifySettings({ uberSettings: newUberSettings });
  };

  //save social handles
  saveSocialHandles = () => {
    const { settings } = this.state;
    this.modifySettings({
      facebook: settings.facebook,
      website: settings.website,
      instagram: settings.instagram,
      facebook_app_id: settings.facebook_app_id,
      facebook_secret: settings.facebook_secret,
      facebook_access_token: settings.facebook_access_token,
      facebook_page_id: settings.facebook_page_id,
      youtube: settings.youtube,
      linkedin: settings.linkedin,
      xapp: settings.xapp,
      whatsappNumber: settings.whatsappNumber
    });
  };

  saveHolidays = () => {
    const { isHoliday } = this.state.settings;
    this.handleHolidayAutoSave(isHoliday);
  }

  handleHolidayAutoSave = (newHolidays) => {
    // 1. Update Local State immediately for UI responsiveness
    this.setState(prevState => ({
      settings: {
        ...prevState.settings,
        isHoliday: newHolidays
      }
    }), () => {
      // 2. Sanitize and Save to DB
      const sanitizedHolidays = newHolidays.map(col => {
        const newCol = { ...col };
        if (newCol._id && (newCol._id.length !== 24 || !/^[0-9a-fA-F]{24}$/.test(newCol._id))) {
          delete newCol._id;
        }

        if (newCol.holidays) {
          newCol.holidays = newCol.holidays.map(h => {
            const hCopy = { ...h };
            if (hCopy._id && (hCopy._id.length !== 24 || !/^[0-9a-fA-F]{24}$/.test(hCopy._id))) {
              delete hCopy._id;
            }
            return hCopy;
          });
        }

        return newCol;
      });
      this.modifySettings({ isHoliday: sanitizedHolidays });
    });
  }

  // Update Specific data only
  modifySettings = async (requestObject) => {
    // requestObject as Object
    const { updateSettings, messageShow } = this.props;
    const { vendorId } = this.state.settings;
    const { data } = await updateSettings({ vendorId, requestObject });
    this.isSubmittingToggle(false);
    messageShow(data.message);
  };

  onCloseEvent = (mode, index) => {
    let { workingHours } = this.state.settings;
    if (mode === "bStartTime") {
      workingHours[index].bEndTime = dayjs(
        workingHours[index].bStartTime
      ).format();
    }
    if (mode === "lStartTime") {
      workingHours[index].lEndTime = dayjs(
        workingHours[index].lStartTime
      ).format();
    }
    const settings = { ...this.state.settings, workingHours: workingHours };
    this.setState({ settings: settings });
  };

  render() {
    const { classes } = this.props;
    const {
      isSubmitting,
      settings,
      newCharge,
      isUploadingFile,
      isUploadingFile2,
      showPassword,
      isSquarePay,
      isRazorPay,
      isStripe,
      permissions
    } = this.state;
  
    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" classes={classes.grow}>
            Settings
          </Typography>
        </Toolbar>

        {settings?.modifiedBy?.name && settings?.updatedAt && (
          <Box sx={{ paddingLeft: 2, paddingTop: 2 }}>
            <Box
              sx={{
                display: 'inline-block',
                backgroundColor: '#e0f7fa',
                color: '#00796b',
                borderRadius: '12px',
                padding: '6px 12px',
                fontSize: '0.8rem',
                fontWeight: 500,
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}
            >
              Last modified by {settings.modifiedBy.name} at{' '}
              {dayjs(settings.updatedAt).format('DD-MM-YYYY, hh:mm A')}
            </Box>
          </Box>
        )}

        <div style={{ padding: "18px" }}>
          <Grid item xs={12}>
            {/* App Configuration */}
            <Accordion
              expanded={this.state.expanded === "panel1"}
              onChange={(event) => this.handleAccordion("panel1")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className="w-1/3">
                  <b>App Config</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <form>
                  {/* First Row */}
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel id="demo-simple-select-label">
                          Timezone
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={settings.timeZone}
                          name="timeZone"
                          label="- Choose Timezone -"
                          variant="standard"
                          onChange={(event) =>
                            this.appConfigChange("timeZone", event.target.value)
                          }
                        >
                          <MenuItem selected disabled>
                            - Choose Timezone -
                          </MenuItem>
                          {timeZones?.map((eTime, eIndex) => (
                            <MenuItem key={eIndex} value={eTime?.zone}>
                              {eTime.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel id="demo-simple-select-label">
                          Country Code
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={settings.countryCode}
                          name="countryCode"
                          label="- Choose Country Code -"
                          variant="standard"
                          onChange={this.onChangeCountryCode}
                        >
                          <MenuItem selected disabled>
                            - Choose Country Code -
                          </MenuItem>
                          {this.state.countryCodes.map((country) => (
                            <MenuItem key={country._id} value={country._id}>
                              {`${country.code} ${country.name}`}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  {/* Second Row */}
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"aboutUs"}
                        type={"url"}
                        value={nullToEmptyString(settings.aboutUs)}
                        onChange={this.onChange}
                        label={"About Us URL"}
                        placeholder={"Enter About Us URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"terms"}
                        type={"url"}
                        value={nullToEmptyString(settings.terms)}
                        onChange={this.onChange}
                        label={"Terms URL"}
                        placeholder={"Enter Terms URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  {/* Third Row */}
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"privacyPolicy"}
                        type={"url"}
                        value={nullToEmptyString(settings.privacyPolicy)}
                        onChange={this.onChange}
                        label={"Privacy Policy URL"}
                        placeholder={"Enter Privacy Policy URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"faq"}
                        value={nullToEmptyString(settings.faq)}
                        onChange={this.onChange}
                        label={"Faq URL"}
                        placeholder={"Enter Faq URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  {/* fourth Row */}
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"feedback"}
                        type={"url"}
                        value={nullToEmptyString(settings.feedback)}
                        onChange={this.onChange}
                        label={"Feedback URL"}
                        placeholder={"Enter Feedback URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"tableBooking"}
                        type={"url"}
                        value={nullToEmptyString(settings.tableBooking)}
                        onChange={this.onChange}
                        label={"Table Booking URL"}
                        placeholder={"Enter Table Booking URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"email"}
                        value={nullToEmptyString(settings.email)}
                        onChange={this.onChange}
                        label={"Email"}
                        placeholder={"Enter Email"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"webAppUrl"}
                        value={nullToEmptyString(settings.webAppUrl)}
                        onChange={this.onChange}
                        label={"Web App URL"}
                        placeholder={"Enter Web App URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"qrDiningAppUrl"}
                        value={nullToEmptyString(settings.qrDiningAppUrl)}
                        onChange={this.onChange}
                        label={"Qr Dining App URL"}
                        placeholder={"Enter Qr Dining App URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                    {
                      (this.state.roleName === "Super Admin" || this.state.settings.isCampaignSubscribed) && (
                        <Grid item xs={6}>
                          <TextField
                            variant="standard"
                            name={"campaignUrl"}
                            value={nullToEmptyString(settings.campaignUrl)}
                            onChange={this.onChange}
                            label={"Marketing Campaign URL"}
                            placeholder={"Enter Marketing Campaign URL"}
                            margin={"dense"}
                            autoComplete={"off"}
                            fullWidth
                          />
                        </Grid>)
                    }
                    {
                      (this.state.roleName === "Super Admin" || this.state.settings.isInvoiceSubscribed) && (
                        <Grid item xs={6}>
                          <TextField
                            variant="standard"
                            name={"invoicesUrl"}
                            value={nullToEmptyString(settings.invoicesUrl)}
                            onChange={this.onChange}
                            label={"Invoices URL"}
                            placeholder={"Enter Invoices URL"}
                            margin={"dense"}
                            autoComplete={"off"}
                            fullWidth
                          />
                        </Grid>)
                    }
                    {
                      (this.state.roleName === "Super Admin" || this.state.settings.isSeoOptimizationEnabled) && (
                        <Grid item xs={6}>
                          <TextField
                            variant="standard"
                            name={"seoUrl"}
                            value={nullToEmptyString(settings.seoUrl)}
                            onChange={this.onChange}
                            label={"SEO URL"}
                            placeholder={"Enter Marketing SEO URL"}
                            margin={"dense"}
                            autoComplete={"off"}
                            fullWidth
                          />
                        </Grid>)
                    }
                    {/* 
                      this.state.roleName === "Super Admin" && (
                        <Grid item xs={6}>
                          <TextField
                            variant="standard"
                            name={"daisyToken"}
                            value={nullToEmptyString(settings.daisyToken)}
                            onChange={this.onChange}
                            label={"Daisy Token"}
                            placeholder={"Enter Daisy Token"}
                            margin={"dense"}
                            autoComplete={"off"}
                            fullWidth
                          />
                        </Grid>
                    )*/}
                  </Grid>
                  <b>Mobile App URL</b>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"iosAppUrl"}
                        type={"url"}
                        value={nullToEmptyString(settings.iosAppUrl)}
                        onChange={this.onChange}
                        label={"Ios App URL"}
                        placeholder={"Enter Ios App URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"androidAppUrl"}
                        type={"url"}
                        value={nullToEmptyString(settings.androidAppUrl)}
                        onChange={this.onChange}
                        label={"Android App URL"}
                        placeholder={"Enter Android App URL"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        name={"onlinePricingPercentage"}
                        value={nullToEmptyString(
                          settings.onlinePricingPercentage
                        )}
                        onChange={this.onChange}
                        label={"Online Price Percentage"}
                        placeholder={"Enter Online Price Percentage"}
                        margin={"dense"}
                        autoComplete={"off"}
                        fullWidth
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <b>Company Logo</b>
                      <Grid
                        container
                        spacing={10}
                        className={classes.buttonUpload}
                        alignItems="center"
                      >
                        <Grid item md={6}>
                          {!this.state.previewImage ? (
                            <ImageComp
                              src={getImageSource(`${settings.image}`)}
                              defaultSrc={getImageSource()}
                              size={"100%"}
                            />
                          ) : (
                            <img
                              height="auto"
                              width="100%"
                              src={this.state.previewImage}
                              alt="preview_banner"
                            ></img>
                          )}
                        </Grid>
                        <Grid item md={6}>
                          <input
                            accept={"image/png,image/jpeg"}
                            style={{ display: "none" }}
                            id={"company-contained-button-file"}
                            type={"file"}
                            onChange={this.onUpload}
                            disabled={!permissions.canEdit}
                          />

                          <label htmlFor={"company-contained-button-file"}>
                            <Button
                              variant={"outlined"}
                              component={"span"}
                              type={"file"}
                              fullWidth
                              disabled={isUploadingFile || !permissions.canEdit}
                            >
                              Upload Image
                            </Button>
                          </label>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <b>Default Image</b>
                      <Grid
                        container
                        spacing={10}
                        className={classes.buttonUpload}
                        alignItems="center"
                      >
                        <Grid item md={6}>
                          {!this.state.previewImage2 ? (
                            <ImageComp
                              src={getImageSource(`${settings.logo}`)}
                              defaultSrc={getImageSource()}
                              size={"100%"}
                            />
                          ) : (
                            <img
                              height="auto"
                              width="100%"
                              src={this.state.previewImage2}
                              alt="preview_banner"
                            ></img>
                          )}
                        </Grid>
                        <Grid item md={6}>
                          <input
                            accept={"image/png,image/jpeg"}
                            style={{ display: "none" }}
                            id={"default-contained-button-file"}
                            type={"file"}
                            onChange={this.onUpload2}
                            disabled={!permissions.canEdit}
                          />

                          <label htmlFor={"default-contained-button-file"}>
                            <Button
                              variant={"outlined"}
                              component={"span"}
                              type={"file"}
                              fullWidth
                              disabled={isUploadingFile2 || !permissions.canEdit}
                            >
                              Upload logo
                            </Button>
                          </label>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <div className="col-12 py-2 text-end">
                    <Grid
                      container
                      justifyContent="center"
                      className={classes.buttonsContainer}
                    >
                      <Button
                        aria-label={"Save"}
                        size="medium"
                        color={"primary"}
                        disabled={isSubmitting || !permissions.canEdit}
                        variant="contained"
                        onClick={this.saveAppConfig}
                      >
                        Save
                      </Button>
                    </Grid>
                  </div>
                </form>
              </AccordionDetails>
            </Accordion>
            {/*  User Preferences Configuration */}
            <Accordion
              expanded={this.state.expanded === "panel8"}
              onChange={(event) => this.handleAccordion("panel8")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className="w-1/3">
                  <b>User Preference</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <form>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel id="view-mode-label">View mode</InputLabel>
                        <Select
                          labelId="view-mode-label"
                          value={settings.viewMode}
                          name="viewMode"
                          label="View mode"
                          variant="standard"
                          onChange={(e) =>
                            this.setState((prev) => ({
                              settings: {
                                ...prev.settings,
                                viewMode: e.target.value,
                              },
                            }))
                          }
                        >
                          <MenuItem disabled>- Choose View -</MenuItem>
                          <MenuItem value="grid">Grid</MenuItem>
                          <MenuItem value="list">List</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <div className="col-12 py-2 text-end">
                      <Grid
                        container
                        justifyContent="center"
                        className={classes.buttonsContainer}
                      >
                        <Button
                          aria-label={"Save"}
                          size="medium"
                          color={"primary"}
                          disabled={isSubmitting || !permissions.canEdit}
                          variant="contained"
                          onClick={this.saveUserpreferences}
                        >
                          Save
                        </Button>
                      </Grid>
                    </div>
                  </Grid>
                </form>
              </AccordionDetails>
            </Accordion>
            {/* Taxes and Charges */}
            <Accordion
              expanded={this.state.expanded === "panel4"}
              onChange={(event) => this.handleAccordion("panel4")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography sx={{ width: "33%", flexShrink: 0 }}>
                  <b>Taxes and Charges</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={3}>
                  <Grid container item spacing={2} xs={12}>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Currency
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={settings.currency}
                          name="currency"
                          label="- Choose Currency -"
                          variant="standard"
                          onChange={this.onChangeCurrency}
                        >
                          <MenuItem selected disabled>
                            - Choose Currency -
                          </MenuItem>
                          {this.state.currencies.map((currency) => (
                            <MenuItem key={currency._id} value={currency._id}>
                              {currency.symbol} {currency.code}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id="standard-basic"
                        label="Tax Percentage"
                        placeholder="Enter Tax Percentage"
                        variant="standard"
                        name="taxAmount"
                        value={nullToEmptyString(settings.taxAmount)}
                        onChange={(event) =>
                          this.taxChargeChange("taxAmount", event.target.value)
                        }
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>Charges :</Typography>
                  </Grid>
                  <Grid container item xs={12} spacing={2}>
                    <Grid item xs={4}>
                      <TextField
                        label="Charge Label"
                        value={nullToEmptyString(newCharge.label)}
                        onChange={(event) =>
                          this.newChargeChange("label", event.target.value)
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label="Charge Amount"
                        value={nullToEmptyString(newCharge.amount)}
                        onChange={(event) =>
                          this.newChargeChange("amount", event.target.value)
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.addNewCharge}
                        disabled={!permissions.canEdit}
                      >
                        Add Charge
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>Existing Charges :</Typography>
                  </Grid>
                  <Grid container item xs={12}>
                    {settings.charges?.length > 0 ? (
                      settings.charges.map((charge, index) => (
                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          key={index}
                          style={{ paddingBottom: "10px" }}
                        >
                          <Grid item xs={4}>
                            <TextField
                              label="Charge Label"
                              value={charge.label}
                              onChange={(e) =>
                                this.onChargeChange(
                                  index,
                                  "label",
                                  e.target.value
                                )
                              }
                              fullWidth
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <TextField
                              label="Charge Amount"
                              value={charge.amount}
                              onChange={(e) =>
                                this.onChargeChange(
                                  index,
                                  "amount",
                                  e.target.value
                                )
                              }
                              fullWidth
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => this.removeCharge(index)}
                            >
                              Remove Charge
                            </Button>
                          </Grid>
                        </Grid>
                      ))
                    ) : (
                      <Grid item xs={12}>
                        <Typography>No Existing Charges</Typography>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <div className="col-12 py-2 text-end">
                  <Grid
                    container
                    justifyContent="center"
                    className={classes.buttonsContainer}
                  >
                    <Button
                      aria-label={"Save"}
                      size="medium"
                      color={"primary"}
                      disabled={isSubmitting || !permissions.canEdit}
                      variant="contained"
                      onClick={this.saveTaxCharges}
                    >
                      Save
                    </Button>
                  </Grid>
                </div>
              </AccordionDetails>
            </Accordion>
            {/* Payment Configuration */}
            <>
              <Accordion
                expanded={this.state.expanded === "panel3"}
                onChange={() => this.handleAccordion("panel3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                >
                  <Typography sx={{ width: "33%", flexShrink: 0 }}>
                    <b>Payment Setup</b>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <form autoComplete="off">
                    <div className="col-12 d-lg-flex flex-lg-row flex-lg-nowrap justify-content-lg-between">
                      <div className="col-lg-6 col-md-12 px-3 pb-3">
                        <TextField
                          variant="standard"
                          name={"phoneLine1"}
                          value={nullToEmptyString(settings.phoneLine1)}
                          onChange={this.onChange}
                          label={"Phone Line 1"}
                          placeholder={"Enter phone line 1"}
                          required={true}
                          margin={"dense"}
                          autoComplete={"off"}
                          autoFocus
                          fullWidth
                        />
                      </div>
                      <div className="col-lg-6 col-md-12 px-3 pb-3">
                        <TextField
                          variant="standard"
                          name={"phoneLine2"}
                          value={nullToEmptyString(settings.phoneLine2)}
                          onChange={this.onChange}
                          label={"Phone Line 2"}
                          placeholder={"Enter phone line 2"}
                          margin={"dense"}
                          autoComplete={"off"}
                          fullWidth
                        />
                      </div>

                    </div>
                    <b>Payment Method</b>
                    <Grid container spacing={2} style={{ margin: "10px" }}>
                      <Grid item xs={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={settings.paymentConfiguration?.find(p => p.name === "SQUARE_PAY")?.isEnabled || isSquarePay || false}
                              onChange={(e) => this.handlePaymentMethodToggle(e, 'isSquarePay')}
                              name="isSquarePay"
                              color="primary"
                            />
                          }
                          label="Square Pay"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={settings.paymentConfiguration?.find(p => p.name === "RAZOR_PAY")?.isEnabled || isRazorPay || false}
                              onChange={(e) => this.handlePaymentMethodToggle(e, 'isRazorPay')}
                              name="isRazorPay"
                              color="primary"
                            />
                          }
                          label="Razor Pay"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={settings.paymentConfiguration?.find(p => p.name === "STRIPE")?.isEnabled || isStripe || false}
                              onChange={(e) => this.handlePaymentMethodToggle(e, 'isStripe')}
                              name="isStripe"
                              color="primary"
                            />
                          }
                          label="Stripe"
                        />
                      </Grid>
                    </Grid>

                    {/* ---------------------- SQUARE PAY ---------------------- */}
                    {isSquarePay && (
                      <Box sx={{ mt: 3, pl: 3 }}>
                        <Typography variant="h6" style={{ marginBottom: '15px' }}>
                          Square Pay
                        </Typography>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Active Environment</FormLabel>
                          <RadioGroup
                            row
                            name="squarePayEnv"
                            value={this.state.squarePayEnv}
                            onChange={(e) => this.handleEnvChange('SQUARE_PAY', e.target.value)}
                          >
                            <FormControlLabel value="sandbox" control={<Radio />} label="Sandbox" />
                            <FormControlLabel value="production" control={<Radio />} label="Production" />
                          </RadioGroup>
                        </FormControl>
                        <TabContext value={this.state.squareTabValue || "sandbox"}>
                          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                            <TabList
                              onChange={(e, v) => this.setState({ squareTabValue: v })}
                              aria-label="Square Pay environment tabs"
                            >
                              <Tab label="Sandbox" value="sandbox" />
                              <Tab label="Production" value="production" />
                            </TabList>
                          </Box>
                          {/* SANDBOX */}
                          <TabPanel value="sandbox" sx={{ p: 0 }}>
                            <Grid container spacing={2}>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="accessKey"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "SQUARE_PAY")?.config[0]?.accessKey || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "SQUARE_PAY", 0)}
                                  label="Sandbox Application Id"
                                  placeholder="Enter Sandbox Application Id"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="accessToken"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "SQUARE_PAY")?.config[0]?.accessToken || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "SQUARE_PAY", 0)}
                                  label="Sandbox Access Token"
                                  placeholder="Enter Sandbox Access Token"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  type={this.state.showPassword ? "text" : "password"}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={this.togglePasswordVisibility}
                                          edge="end"
                                        >
                                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="locationId"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "SQUARE_PAY")?.config[0]?.locationId || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "SQUARE_PAY", 0)}
                                  label="Sandbox Location Id"
                                  placeholder="Enter Sandbox Location Id"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                            </Grid>
                          </TabPanel>
                          {/* PRODUCTION */}
                          <TabPanel value="production" sx={{ p: 0 }}>
                            <Grid container spacing={2}>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="accessKey"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "SQUARE_PAY")?.config[1]?.accessKey || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "SQUARE_PAY", 1)}
                                  label="Production Application Id"
                                  placeholder="Enter Production Application Id"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="accessToken"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "SQUARE_PAY")?.config[1]?.accessToken || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "SQUARE_PAY", 1)}
                                  label="Production Access Token"
                                  placeholder="Enter Production Access Token"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  type={this.state.showPassword ? "text" : "password"}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={this.togglePasswordVisibility}
                                          edge="end"
                                        >
                                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="locationId"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "SQUARE_PAY")?.config[1]?.locationId || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "SQUARE_PAY", 1)}
                                  label="Production Location Id"
                                  placeholder="Enter Production Location Id"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                            </Grid>
                          </TabPanel>
                        </TabContext>
                      </Box>
                    )}

                    {/* ---------------------- RAZORPAY ---------------------- */}
                    {isRazorPay && (
                      <Box sx={{ mt: 3, pl: 3 }}>
                        <Typography variant="h6" style={{ marginBottom: '15px' }}>
                          Razor Pay
                        </Typography>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Active Environment</FormLabel>
                          <RadioGroup
                            row
                            name="razorPayEnv"
                            value={this.state.razorPayEnv}
                            onChange={(e) => this.handleEnvChange('RAZOR_PAY', e.target.value)}
                          >
                            <FormControlLabel value="sandbox" control={<Radio />} label="Sandbox" />
                            <FormControlLabel value="production" control={<Radio />} label="Production" />
                          </RadioGroup>
                        </FormControl>

                        <TabContext value={this.state.razorpayTabValue || "sandbox"}>
                          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                            <TabList
                              onChange={(e, v) => this.setState({ razorpayTabValue: v })}
                              aria-label="Razorpay environment tabs"
                            >
                              <Tab label="Sandbox" value="sandbox" />
                              <Tab label="Production" value="production" />
                            </TabList>
                          </Box>
                          {/* SANDBOX */}
                          <TabPanel value="sandbox" sx={{ p: 0 }}>
                            <Grid container spacing={2}>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="keyId"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "RAZOR_PAY")?.config[0]?.keyId || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "RAZOR_PAY", 0)}
                                  label="Sandbox Key Id"
                                  placeholder="Enter Razorpay Sandbox Key Id"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="keySecret"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "RAZOR_PAY")?.config[0]?.keySecret || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "RAZOR_PAY", 0)}
                                  label="Sandbox Key Secret"
                                  placeholder="Enter Razorpay Sandbox Key Secret"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  type={this.state.showPassword ? "text" : "password"}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={this.togglePasswordVisibility}
                                          edge="end"
                                        >
                                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                            </Grid>
                          </TabPanel>
                          {/* PRODUCTION */}
                          <TabPanel value="production" sx={{ p: 0 }}>
                            <Grid container spacing={2}>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="keyId"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "RAZOR_PAY")?.config[1]?.keyId || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "RAZOR_PAY", 1)}
                                  label="Production Key Id"
                                  placeholder="Enter Razorpay Production Key Id"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="keySecret"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "RAZOR_PAY")?.config[1]?.keySecret || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "RAZOR_PAY", 1)}
                                  label="Production Key Secret"
                                  placeholder="Enter Razorpay Production Key Secret"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  type={this.state.showPassword ? "text" : "password"}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={this.togglePasswordVisibility}
                                          edge="end"
                                        >
                                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                            </Grid>
                          </TabPanel>
                        </TabContext>
                      </Box>
                    )}

                    {/* ---------------------- STRIPE ---------------------- */}
                    {isStripe && (
                      <Box sx={{ mt: 3, pl: 3 }}>
                        <Typography variant="h6" style={{ marginBottom: '15px' }}>
                          Stripe
                        </Typography>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Active Environment</FormLabel>
                          <RadioGroup
                            row
                            name="stripeEnv"
                            value={this.state.stripeEnv}
                            onChange={(e) => this.handleEnvChange('STRIPE', e.target.value)}
                          >
                            <FormControlLabel value="sandbox" control={<Radio />} label="Sandbox" />
                            <FormControlLabel value="production" control={<Radio />} label="Production" />
                          </RadioGroup>
                        </FormControl>

                        <TabContext value={this.state.stripeTabValue || "sandbox"}>
                          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                            <TabList
                              onChange={(e, v) => this.setState({ stripeTabValue: v })}
                              aria-label="Stripe environment tabs"
                            >
                              <Tab label="Sandbox" value="sandbox" />
                              <Tab label="Production" value="production" />
                            </TabList>
                          </Box>
                          {/* SANDBOX */}
                          <TabPanel value="sandbox" sx={{ p: 0 }}>
                            <Grid container spacing={2}>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="stripePublishableKey"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "STRIPE")?.config[0]?.stripePublishableKey || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "STRIPE", 0)}
                                  label="Sandbox Publishable Key"
                                  placeholder="Enter Stripe Sandbox Publishable Key"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="stripeSecretKey"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "STRIPE")?.config[0]?.stripeSecretKey || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "STRIPE", 0)}
                                  label="Sandbox Secret Key"
                                  placeholder="Enter Stripe Sandbox Secret Key"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  type={this.state.showPassword ? "text" : "password"}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={this.togglePasswordVisibility}
                                          edge="end"
                                        >
                                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                            </Grid>
                          </TabPanel>
                          {/* PRODUCTION */}
                          <TabPanel value="production" sx={{ p: 0 }}>
                            <Grid container spacing={2}>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="stripePublishableKey"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "STRIPE")?.config[1]?.stripePublishableKey || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "STRIPE", 1)}
                                  label="Production Publishable Key"
                                  placeholder="Enter Stripe Production Publishable Key"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <TextField
                                  variant="standard"
                                  name="stripeSecretKey"
                                  value={
                                    settings.paymentConfiguration?.find(pc => pc.name === "STRIPE")?.config[1]?.stripeSecretKey || ""
                                  }
                                  onChange={e => this.onPaymentConfigChange(e, "STRIPE", 1)}
                                  label="Production Secret Key"
                                  placeholder="Enter Stripe Production Secret Key"
                                  margin="dense"
                                  autoComplete="off"
                                  fullWidth
                                  type={this.state.showPassword ? "text" : "password"}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={this.togglePasswordVisibility}
                                          edge="end"
                                        >
                                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                            </Grid>
                          </TabPanel>
                        </TabContext>
                      </Box>
                    )}

                    <div className="col-12 py-2 text-end">
                      <Grid
                        container
                        justifyContent="center"
                        className={this.props.classes.buttonsContainer}
                      >
                        <Button
                          aria-label={"Save"}
                          size="medium"
                          color={"primary"}
                          disabled={this.state.isSubmitting || !this.state.permissions.canEdit}
                          variant="contained"
                          onClick={this.savePaymentConfig}
                        >
                          Save
                        </Button>
                      </Grid>
                    </div>
                  </form>
                </AccordionDetails>
              </Accordion>

            </>
            {/* Delivery and Make Payment Screen Setup */}
            <Accordion
              expanded={this.state.expanded === "panel5"}
              onChange={(event) => this.handleAccordion("panel5")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5bh-content"
                id="panel5bh-header"
              >
                <Typography className="w-1/3">
                  <b>Checkout Setup</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <b>Display Message Box</b>
                <form>
                  {/* First Row */}
                  <Grid container spacing={2} style={{ margin: "10px" }}>
                    <Grid item xs={12} sm={7}>
                      <TextField
                        variant="standard"
                        label="Info Message 1"
                        name="infomsg1"
                        value={nullToEmptyString(settings.infomsg1)}
                        onChange={this.onChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <TextField
                        variant="standard"
                        label="Info Message 2"
                        name="infomsg2"
                        value={nullToEmptyString(settings.infomsg2)}
                        onChange={this.onChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <TextField
                        variant="standard"
                        label="Info Message 3"
                        name="infomsg3"
                        value={nullToEmptyString(settings.infomsg3)}
                        onChange={this.onChange}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <b>Delivery Type </b>

                  <Grid container spacing={2} style={{ margin: "10px" }}>
                    <Grid item xs={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={settings.isPickupAtStore}
                            onChange={this.onChangeisPickupAtStore}
                            name="isPickupAtStore"
                            color="primary"
                          />
                        }
                        label="Pickup At Store"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={settings.isHomeDelivery}
                            onChange={this.onChangeisHomeDeliveryy}
                            name="isHomeDelivery"
                            color="primary"
                          />
                        }
                        label="Home Delivery"
                      />
                    </Grid>
                  </Grid>

                  <section id="menu" className="mt-5">
                    <Container fluid>
                      <Row className="mb-10 justify-content-center">
                        <Col>
                          <Tabs
                            defaultActiveKey="PickUpStore"
                            transition={false}
                          >
                            {settings.isPickupAtStore && (
                              <Tab
                                eventKey="PickUpStore"
                                title={
                                  <h1 style={{ fontSize: "15px" }}>
                                    Pickup At Store
                                  </h1>
                                }
                                style={{ color: "blue" }}
                              >
                                <form>
                                  <Grid
                                    container
                                    spacing={2}
                                    style={{ margin: "20px" }}
                                    alignItems="center"
                                  >
                                    {/* Pickup */}
                                    <Grid item xs={3}>
                                      <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">
                                          {" "}
                                          Payment Mode{" "}
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={nullToEmptyString(
                                            (settings.pickupAtStore &&
                                              settings.pickupAtStore
                                                .paymentMethods) ||
                                            []
                                          )}
                                          name="pickup"
                                          label="- Choose Payment Mode -"
                                          variant="standard"
                                          multiple // Enable multiple selection
                                          onChange={this.onChangePickup}
                                          renderValue={(selected) => (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                              }}
                                            >
                                              {selected.map((value) => {
                                                switch (value) {
                                                  case "PAY_ONLINE":
                                                    return (
                                                      <Chip
                                                        key={value}
                                                        label="Pay Online"
                                                      />
                                                    );
                                                  case "WEB_ONLY_PAY_ONLINE":
                                                    return (
                                                      <Chip
                                                        key={value}
                                                        label="Web Only Pay Online"
                                                      />
                                                    );
                                                  case "PAY_AT_STORE":
                                                    return (
                                                      <Chip
                                                        key={value}
                                                        label="Pay at Store"
                                                      />
                                                    );
                                                  default:
                                                    const partnerObject =
                                                      this.state.pickupPaymentMode.find(
                                                        (partner) =>
                                                          partner._id === value
                                                      );
                                                    return partnerObject ? (
                                                      <Chip
                                                        key={value}
                                                        label={
                                                          partnerObject.name
                                                        }
                                                      />
                                                    ) : null;
                                                }
                                              })}
                                            </div>
                                          )}
                                        >
                                          <MenuItem disabled>
                                            - Choose Pickup Payment Mode -
                                          </MenuItem>
                                          <MenuItem value="PAY_ONLINE">
                                            Pay Online
                                          </MenuItem>
                                          <MenuItem value="WEB_ONLY_PAY_ONLINE">
                                            Web Only Pay Online
                                          </MenuItem>
                                          <MenuItem value="PAY_AT_STORE">
                                            Pay at Store
                                          </MenuItem>
                                          {this.state.pickupPaymentMode.map(
                                            (partner) => (
                                              <MenuItem
                                                key={partner._id}
                                                value={partner._id}
                                              >
                                                {partner.name}
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    {(settings.pickupAtStore.paymentMethods || []).includes("PAY_AT_STORE") && (
                                      <Grid item xs={3}>
                                        <TextField
                                          variant="standard"
                                          label="Minimum Cash Amount"
                                          name="minimumCashAmount"
                                          value={settings.pickupAtStore.minimumCashAmount || ""}
                                          onChange={this.onChangeMinimumCashAmount}
                                          fullWidth
                                        />
                                      </Grid>
                                    )}
                                    {(settings.pickupAtStore.paymentMethods || []).some(method => ["PAY_ONLINE", "WEB_ONLY_PAY_ONLINE"].includes(method)) && (
                                      <Grid item xs={3}>
                                        <TextField
                                          variant="standard"
                                          label="Minimum Online Amount"
                                          name="minimumOnlineAmount"
                                          value={settings.pickupAtStore.minimumOnlineAmount || ""}
                                          onChange={this.onChangeMinimumOnlineAmount}
                                          fullWidth
                                        />
                                      </Grid>
                                    )}
                                  </Grid>
                                </form>
                              </Tab>
                            )}

                            {settings.isHomeDelivery && (
                              <Tab
                                eventKey="Points"
                                title={
                                  <h1 style={{ fontSize: "15px" }}>
                                    Home Delivery
                                  </h1>
                                }
                              >
                                <Grid
                                  container
                                  spacing={2}
                                  style={{ margin: "20px" }}
                                >
                                  <Grid item xs={5}>
                                    <TextField
                                      variant="standard"
                                      name={"minimumAmount"}
                                      value={nullToEmptyString(
                                        settings.homeDelivery?.minimumAmount
                                      )}
                                      onChange={this.onChangeHomeDelivery}
                                      label={"Minimum delivery amount"}
                                      placeholder={
                                        "Enter Minimum delivery amount"
                                      }
                                      margin={"dense"}
                                      autoComplete={"off"}
                                      fullWidth
                                    />
                                  </Grid>

                                  <Grid item xs={5}>
                                    <FormControl fullWidth>
                                      <InputLabel id="demo-simple-select-label">
                                        {" "}
                                        Payment Mode
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={nullToEmptyString(
                                          settings.homeDelivery
                                            ?.paymentMethods || []
                                        )}
                                        name="homeDelivery"
                                        label="- Choose Home Delivery -"
                                        variant="standard"
                                        multiple // Enable multiple selection
                                        onChange={this.onChangeSelfHomeDelivery}
                                        renderValue={(selected) => {
                                          if (!Array.isArray(selected)) {
                                            return null; // or return some default UI
                                          }

                                          return (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                              }}
                                            >
                                              {selected.map((value) => {
                                                switch (value) {
                                                  case "CASH_ON_DELIVERY":
                                                    return (
                                                      <Chip
                                                        key={value}
                                                        label="Cash on Delivery"
                                                      />
                                                    );
                                                  case "PAY_ONLINE":
                                                    return (
                                                      <Chip
                                                        key={value}
                                                        label="Pay Online"
                                                      />
                                                    );
                                                  default:
                                                    const partnerObject =
                                                      this.state.homeDeliveryPaymentMode.find(
                                                        (partner) =>
                                                          partner._id === value
                                                      );
                                                    return partnerObject ? (
                                                      <Chip
                                                        key={value}
                                                        label={
                                                          partnerObject.name
                                                        }
                                                      />
                                                    ) : null;
                                                }
                                              })}
                                            </div>
                                          );
                                        }}
                                      >
                                        <MenuItem disabled>
                                          - Choose Home Delivery Payment mode -
                                        </MenuItem>
                                        <MenuItem value="CASH_ON_DELIVERY">
                                          Cash on Delivery
                                        </MenuItem>
                                        <MenuItem value="PAY_ONLINE">
                                          Pay Online
                                        </MenuItem>
                                        {this.state.homeDeliveryPaymentMode.map(
                                          (partner) => (
                                            <MenuItem
                                              key={partner._id}
                                              value={partner._id}
                                            >
                                              {partner.name}
                                            </MenuItem>
                                          )
                                        )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs={5}>
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Delivery Type
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={Array.isArray(this.state.settings.homeDelivery.deliveryType) ?
                                          settings.homeDelivery?.deliveryType
                                          : []}
                                        name="deliveryType"
                                        label="- Choose Delivery Type -"
                                        variant="standard"
                                        multiple
                                        onChange={this.onChangedeliverytype}
                                        renderValue={(selected) => {
                                          if (!Array.isArray(selected)) {
                                            return null;
                                          }

                                          return (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                              }}
                                            >
                                              {selected.map((value) => {
                                                switch (value) {
                                                  case "SELF":
                                                    return (
                                                      <Chip
                                                        key={value}
                                                        label="Self"
                                                      />
                                                    );
                                                  case "UBER":
                                                    return (
                                                      <Chip
                                                        key={value}
                                                        label="Uber"
                                                      />
                                                    );
                                                  default:
                                                    return null;
                                                }
                                              })}
                                            </div>
                                          );
                                        }}
                                      >
                                        <MenuItem selected disabled>
                                          - Choose Delivery Type -
                                        </MenuItem>
                                        <MenuItem value="SELF">Self</MenuItem>
                                        <MenuItem value="UBER">Uber</MenuItem>
                                        {/*<MenuItem value="DOOR_DASH">Door Dash</MenuItem> */}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid container spacing={5}>
                                    <Grid item xs={3}>
                                      <TextField
                                        variant="standard"
                                        name="min"
                                        value={this.state.newSlab?.min || ''}
                                        onChange={(e) =>
                                          this.setState({
                                            newSlab: {
                                              ...this.state.newSlab,
                                              min: e.target.value,
                                            },
                                          })
                                        }
                                        label="Min Distance"
                                        placeholder="e.g., 0"
                                        margin="dense"
                                        fullWidth
                                        type="number"
                                        inputProps={{ step: "any" }}
                                      />
                                    </Grid>
                                    <Grid item xs={3}>
                                      <TextField
                                        variant="standard"
                                        name="max"
                                        value={this.state.newSlab?.max || ''}
                                        onChange={(e) =>
                                          this.setState({
                                            newSlab: {
                                              ...this.state.newSlab,
                                              max: e.target.value,
                                            },
                                          })
                                        }
                                        label="Max Distance"
                                        placeholder="e.g., 1"
                                        margin="dense"
                                        fullWidth
                                        type="number"
                                        inputProps={{ step: "any" }}
                                      />
                                    </Grid>
                                    <Grid item xs={3}>
                                      <TextField
                                        variant="standard"
                                        name="rate"
                                        value={this.state.newSlab?.rate || ''}
                                        onChange={(e) =>
                                          this.setState({
                                            newSlab: {
                                              ...this.state.newSlab,
                                              rate: e.target.value,
                                            },
                                          })
                                        }
                                        label="Rate"
                                        placeholder="e.g., 6.6"
                                        margin="dense"
                                        fullWidth
                                        type="number"
                                        inputProps={{ step: "any" }}
                                      />
                                    </Grid>
                                    <Grid item xs={3} style={{ display: "flex", alignItems: "center" }}>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleAddSlab}
                                        disabled={
                                          !this.state.newSlab?.min ||
                                          !this.state.newSlab?.max ||
                                          !this.state.newSlab?.rate
                                        }
                                      >
                                        {this.state.editIndex !== undefined ? "Update" : "Add"}
                                      </Button>
                                    </Grid>

                                    <Grid item xs={12}>
                                      {(this.state.settings.homeDelivery.milesSlabRates || []).length > 0 && (
                                        <Grid item xs={12}>
                                          <Typography variant="subtitle1" style={{ marginBottom: "10px" }}>
                                            Added Slab Rates:
                                          </Typography>
                                          <Table>
                                            <TableHead>
                                              <TableRow>
                                                <TableCell>Min Distance</TableCell>
                                                <TableCell>Max Distance</TableCell>
                                                <TableCell>Rate</TableCell>
                                                <TableCell>Actions</TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {Array.isArray(this.state.settings.homeDelivery.milesSlabRates) &&
                                                this.state.settings.homeDelivery.milesSlabRates.map((slab, index) => (
                                                  <TableRow key={index}>
                                                    <TableCell>{slab.min}</TableCell>
                                                    <TableCell>{slab.max}</TableCell>
                                                    <TableCell>{slab.rate}</TableCell>
                                                    <TableCell>
                                                      <IconButton onClick={() => this.handleEditSlab(index)} >
                                                        <Edit color="primary" />
                                                      </IconButton>
                                                      <IconButton onClick={() => this.handleDeleteSlab(index)} >
                                                        <Delete color="error" />
                                                      </IconButton>
                                                    </TableCell>
                                                  </TableRow>
                                                ))
                                              }
                                            </TableBody>
                                          </Table>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Tab>
                            )}
                          </Tabs>
                        </Col>
                      </Row>
                    </Container>
                  </section>
                  <b style={{ marginLeft: "10px" }}>Order Numbering</b>
                  <Grid container spacing={2} style={{ margin: "10px" }}>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                        Configure how order IDs are generated. Orders will be formatted as <b>PREFIX + padded number</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        variant="standard"
                        label="Order ID Prefix"
                        placeholder="e.g. ORD"
                        value={settings.orderNumbering?.prefix || ''}
                        onChange={(e) => this.onChangeOrderNumbering('prefix', e.target.value)}
                        helperText="Text placed before the number (e.g. ORD)"
                        fullWidth
                        inputProps={{ maxLength: 20 }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        variant="standard"
                        label="Next Order Number"
                        type="number"
                        placeholder="e.g. 1"
                        value={settings.orderNumbering?.nextNumber || ''}
                        onChange={(e) => this.onChangeOrderNumbering('nextNumber', e.target.value)}
                        helperText="The next order will use this number (auto-increments)"
                        fullWidth
                        inputProps={{ min: 1 }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        variant="standard"
                        label="Number Padding (Leading Zeros)"
                        type="number"
                        placeholder="e.g. 5"
                        value={settings.orderNumbering?.zeroPad || ''}
                        onChange={(e) => this.onChangeOrderNumbering('zeroPad', e.target.value)}
                        helperText="Total digits including leading zeros (e.g. 5 → 00001)"
                        fullWidth
                        inputProps={{ min: 1, max: 10 }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="caption" color="textSecondary">
                        Preview: <b>{`${settings.orderNumbering?.prefix ?? 'ORD'}${String(settings.orderNumbering?.nextNumber ?? 1).padStart(settings.orderNumbering?.zeroPad ?? 5, '0')}`}</b>
                      </Typography>
                    </Grid>
                  </Grid>
                  {/* save button */}

                  <div className="col-12 py-2 text-end">
                    <Grid
                      container
                      justifyContent="center"
                      className={classes.buttonsContainer}
                    >
                      <Button
                        aria-label={"Save"}
                        size="medium"
                        color={"primary"}
                        disabled={isSubmitting || !permissions.canEdit}
                        variant="contained"
                        onClick={this.saveDeliverySetup}
                      >
                        Save
                      </Button>
                    </Grid>
                  </div>
                </form>
              </AccordionDetails>
            </Accordion>
            {/* Uber Settings */}
            <Accordion
              expanded={this.state.expanded === "panel6"}
              onChange={(event) => this.handleAccordion("panel6")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                disabled={!settings.isUberDeliveryEnabled}
              >
                <Typography sx={{ width: "33%", flexShrink: 0 }}>
                  <b>Delivery Setup</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={3}>
                  <Grid container item xs={12} spacing={2}>
                    <Grid item xs={4}>
                      <TextField
                        label="Uber Customer Id"
                        value={nullToEmptyString(
                          settings.uberSettings &&
                          settings.uberSettings.uberCustomerId
                        )}
                        onChange={(event) =>
                          this.uberSettingsChange(
                            "uberCustomerId",
                            event.target.value
                          )
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label="Uber Client Id"
                        value={nullToEmptyString(
                          settings.uberSettings &&
                          settings.uberSettings.uberClientId
                        )}
                        onChange={(event) =>
                          this.uberSettingsChange(
                            "uberClientId",
                            event.target.value
                          )
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label="Uber Client Secret"
                        value={nullToEmptyString(
                          settings.uberSettings &&
                          settings.uberSettings.uberClientSecret
                        )}
                        onChange={(event) =>
                          this.uberSettingsChange(
                            "uberClientSecret",
                            event.target.value
                          )
                        }
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <div className="col-12 py-2 text-end">
                  <Grid
                    container
                    justifyContent="center"
                    className={classes.buttonsContainer}
                  >
                    <Button
                      aria-label={"Save"}
                      size="medium"
                      color={"primary"}
                      disabled={isSubmitting || !permissions.canEdit}
                      variant="contained"
                      onClick={this.saveUberSettings}
                    >
                      Save
                    </Button>
                  </Grid>
                </div>
              </AccordionDetails>
            </Accordion>
             {/* Notification Setup */}
            <Accordion
              expanded={this.state.expanded === "panel7"}
              onChange={(event) => this.handleAccordion("panel7")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel7bh-content"
                id="panel7bh-header"
              >
                <Typography className="w-1/3">
                  <b>Alert Settings</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <form>
                  <Grid container spacing={2} style={{ marginBottom: "15px" }}>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.isAutoAcceptOrdersEnabled}
                            onChange={this.onChangeAutoAcceptOrders}
                            name="isAutoAcceptOrdersEnabled"
                            color="primary"
                          />
                        }
                        label={
                          <div style={{ marginRight: "20px" }}>
                            <Typography style={{ fontWeight: 'bold' }}>Auto Accept Orders</Typography>
                            <Typography variant="body2" style={{ color: "#666" }}>
                              Automatically accept incoming online orders
                            </Typography>
                          </div>
                        }
                        labelPlacement="start"
                        style={{ marginRight: 0 }} 
                      />
                    </Grid>
                  </Grid>
                  <b style={{ marginLeft: '15px' }}>SMS</b>
                  <Typography variant="body2" style={{ margin: "10px 10px 0px 15px", color: "#555" }}>
                    To receive SMS notifications for Orders or Table Reservations, please enable the desired option and provide a valid phone number.
                  </Typography>
                  <Grid container spacing={2} style={{ margin: "10px" }}>
                    <Grid item xs={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={settings.isOrderSmsEnabled}
                            onChange={this.onChangeisSmsEnabled}
                            name="isOrderSmsEnabled"
                            color="primary"
                          />
                        }
                        label="Order SMS"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={settings.isTableReservationSmsEnabled}
                            onChange={this.onChangeisSmsEnabled}
                            name="isTableReservationSmsEnabled"
                            color="primary"
                          />
                        }
                        label="Table Reservation SMS"
                      />
                    </Grid>
                  </Grid>

                  <section id="menu" className="mt-5">
                    <Container fluid>
                      <Row className="mb-10 justify-content-center">
                        <Col>
                          <Tabs
                            defaultActiveKey="SMS"
                            transition={false}
                          >
                            {(settings.isOrderSmsEnabled || settings.isTableReservationSmsEnabled) && (
                              <Tab
                                eventKey="SMS"
                                title={
                                  <h1 style={{ fontSize: "15px" }}>
                                    SMS
                                  </h1>
                                }
                                style={{ color: "blue" }}
                              >
                                <form>
                                  <Grid
                                    container
                                    spacing={2}
                                    style={{ margin: "20px" }}
                                  >
                                    <Grid item xs={4}>
                                      <TextField
                                        variant="standard"
                                        name={"phoneNumber"}
                                        type="number"
                                        value={
                                          nullToEmptyString(settings.Sms?.phoneNumber).replace(this.getSelectedCountryCode(), '')
                                        }
                                        onChange={this.onChangePhoneNumber}
                                        label={"Phone Number"}
                                        placeholder={
                                          "Enter Phone Number"
                                        }
                                        margin={"dense"}
                                        autoComplete={"off"}
                                        fullWidth
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              {this.getSelectedCountryCode()}
                                            </InputAdornment>
                                          )
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </form>
                              </Tab>
                            )}
                          </Tabs>
                        </Col>
                      </Row>
                    </Container>
                  </section>

                  <div className="col-12 py-2 text-end">
                    <Grid
                      container
                      justifyContent="center"
                      className={classes.buttonsContainer}
                    >
                      <Button
                        aria-label={"Save"}
                        size="medium"
                        color={"primary"}
                        disabled={isSubmitting || !permissions.canEdit}
                        variant="contained"
                        onClick={this.saveNotificationSetup}
                      >
                        Save
                      </Button>
                    </Grid>
                  </div>
                </form>
              </AccordionDetails>
            </Accordion>
             {/* Social Handles and Configurations */}
            <Accordion
              expanded={this.state.expanded === "socialHandlesPanel"}
              onChange={(event) => this.handleAccordion("socialHandlesPanel")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography sx={{ width: "33%", flexShrink: 0 }}>
                  <b>Social Links</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="col-12">
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="Facebook"
                        name="facebook"
                        value={settings?.facebook}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "facebook",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="Website"
                        name="website"
                        value={settings?.website}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "website",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="Instagram"
                        name="instagram"
                        value={settings?.instagram}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "instagram",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="Youtube"
                        name="youtube"
                        value={settings?.youtube}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "youtube",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="LinkedIn"
                        name="linkedin"
                        value={settings?.linkedin}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "linkedin",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="X"
                        name="xapp"
                        value={settings?.xapp}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "xapp",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="WhatsApp Number"
                        name="whatsappNumber"
                        value={settings?.whatsappNumber}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "whatsappNumber",
                              value: event.target.value,
                            },
                          })
                        }
                        placeholder={"e.g., 918489511301"}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="Facebook App Id"
                        name="facebook_app_id"
                        value={settings?.facebook_app_id}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "facebook_app_id",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="Facebook Secret Key"
                        name="facebook_secret"
                        value={settings?.facebook_secret}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "facebook_secret",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="Facebook Access token"
                        name="facebook_access_token"
                        value={settings?.facebook_access_token}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "facebook_access_token",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="standard"
                        label="Facebook Page Id"
                        name="facebook_page_id"
                        value={settings?.facebook_page_id}
                        onChange={(event) =>
                          this.onChange({
                            target: {
                              name: "facebook_page_id",
                              value: event.target.value,
                            },
                          })
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.saveSocialHandles}
                        disabled={!permissions.canEdit}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </AccordionDetails>
            </Accordion>
             {/*  Working Hours Configuration */}
            <Accordion
              expanded={this.state.expanded === "panel2"}
              onChange={(event) => this.handleAccordion("panel2")}
              disabled={!settings.timeZone}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography sx={{ width: "33%", flexShrink: 0 }}>
                  <b>Working Hours</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {!this.state.tabValue ? (
                  <div>Loading.... {this.state.tabValue}</div>
                ) : (
                  <>
                    <TabContext value={this.state.tabValue}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={this.handleTabs}
                          aria-label="lab API tabs example"
                        >
                          <Tab label="Sunday" value="1" />
                          <Tab label="Monday" value="2" />
                          <Tab label="Tuesday" value="3" />
                          <Tab label="Wednesday" value="4" />
                          <Tab label="Thursday" value="5" />
                          <Tab label="Friday" value="6" />
                          <Tab label="Saturday" value="7" />
                        </TabList>
                      </Box>
                      {settings.workingHours?.map((eItem, eIndex) => {
                        return (
                          <TabPanel key={eItem.day} value={`${eIndex + 1}`}>
                            <div className="col-12 d-flex flex-column flex-wrap">
                              <div className="col-12 d-flex flex-row align-items-center gap-3 pb-3">
                                <label className="col-2 text-end">
                                  Holiday :
                                </label>
                                <FormControl>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={eItem.isHoliday}
                                        onChange={(event) =>
                                          this.onChangeTime(
                                            null,
                                            null,
                                            eItem.day,
                                            event.target.checked
                                          )
                                        }
                                        name="isHoliday"
                                      />
                                    }
                                  />
                                </FormControl>
                                <label className="col-2 text-end">
                                  Full-Day Hours
                                </label>
                                <FormControl>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={
                                          dayjs(eItem?.bStartTime).format("HH:mm") === "00:00" &&
                                          dayjs(eItem?.bEndTime).format("HH:mm") === "12:00" &&
                                          dayjs(eItem?.lStartTime).format("HH:mm") === "12:00" &&
                                          dayjs(eItem?.lEndTime).format("HH:mm") === "23:59"
                                        }
                                        onChange={(e) =>
                                          this.setFullDayTiming(e.target.checked, eItem.day)
                                        }
                                        disabled={eItem.isHoliday}
                                      />
                                    }
                                  />
                                </FormControl>
                              </div>
                              <div className="col-12 d-flex flex-row align-items-center gap-3 mb-3">
                                <label className="col-2 text-end">
                                  Morning Shift Hours :
                                </label>
                                <div className="col-lg-4 col-md-5 col-sm-12">
                                  <DemoContainer components={["TimePicker"]}>
                                    <TimePicker
                                      label="Start Time"
                                      onChange={(newVal) =>
                                        this.onChangeTime(
                                          newVal,
                                          "bStartTime",
                                          eItem.day
                                        )
                                      }
                                      value={
                                        eItem?.bStartTime
                                          ? dayjs(eItem?.bStartTime)
                                          : null
                                      }
                                      onClose={() =>
                                        this.onCloseEvent("bStartTime", eIndex)
                                      }
                                      disabled={eItem.isHoliday}
                                    />
                                  </DemoContainer>
                                </div>
                                <div className="col-lg-4 col-md-5 col-sm-12">
                                  <DemoContainer components={["TimePicker"]}>
                                    <TimePicker
                                      label="End Time"
                                      onChange={(newVal) =>
                                        this.onChangeTime(
                                          newVal,
                                          "bEndTime",
                                          eItem.day
                                        )
                                      }
                                      minTime={
                                        eItem?.bStartTime
                                          ? dayjs(eItem?.bStartTime)
                                          : null
                                      }
                                      value={
                                        eItem?.bEndTime
                                          ? dayjs(eItem?.bEndTime)
                                          : null
                                      }
                                      disabled={eItem.isHoliday}
                                    />
                                  </DemoContainer>
                                </div>
                                <span className="col">
                                  <Button
                                    color="secondary"
                                    variant="contained"
                                    type="button"
                                    onClick={() =>
                                      this.resetTime(eItem.day, "morn")
                                    }
                                  >
                                    Reset
                                  </Button>
                                </span>
                              </div>
                              <Divider />
                              <div className="col-12 d-flex flex-row align-items-center gap-3 my-3">
                                <label className="col-2 text-end">
                                  Evening Shift Hours :
                                </label>
                                <div className="col-lg-4 col-md-5 col-sm-12">
                                  <DemoContainer components={["TimePicker"]}>
                                    <TimePicker
                                      label="Start Time"
                                      onChange={(newVal) =>
                                        this.onChangeTime(
                                          newVal,
                                          "lStartTime",
                                          eItem.day
                                        )
                                      }
                                      minTime={
                                        eItem?.bEndTime
                                          ? dayjs(eItem?.bEndTime)
                                          : null
                                      }
                                      value={
                                        eItem?.lStartTime
                                          ? dayjs(eItem?.lStartTime)
                                          : null
                                      }
                                      onClose={() =>
                                        this.onCloseEvent("lStartTime", eIndex)
                                      }
                                      disabled={eItem.isHoliday}
                                    />
                                  </DemoContainer>
                                </div>
                                <div className="col-lg-4 col-md-5 col-sm-12">
                                  <DemoContainer components={["TimePicker"]}>
                                    <TimePicker
                                      label="End Time"
                                      onChange={(newVal) =>
                                        this.onChangeTime(
                                          newVal,
                                          "lEndTime",
                                          eItem.day
                                        )
                                      }
                                      minTime={
                                        eItem?.lStartTime
                                          ? dayjs(eItem?.lStartTime)
                                          : null
                                      }
                                      value={
                                        eItem?.lEndTime
                                          ? dayjs(eItem?.lEndTime)
                                          : null
                                      }
                                      disabled={eItem.isHoliday}
                                    />
                                  </DemoContainer>
                                </div>
                                <span>
                                  <Button
                                    color="secondary"
                                    variant="contained"
                                    type="button"
                                    onClick={() =>
                                      this.resetTime(eItem.day, "noon")
                                    }
                                  >
                                    Reset
                                  </Button>
                                </span>
                              </div>
                            </div>
                          </TabPanel>
                        );
                      })}
                    </TabContext>
                    {this.state.settings._id && (
                      <div className="col-12 py-2 text-center">
                        <Grid
                          container
                          justifyContent="center"
                          item
                          className={classes.buttonsContainer}
                        >
                          <Button
                            aria-label={"Save"}
                            size="medium"
                            color={"primary"}
                            disabled={isSubmitting || !permissions.canEdit}
                            variant="contained"
                            onClick={this.saveAppWorkingHours}
                          >
                            Save
                          </Button>
                        </Grid>
                      </div>
                    )}
                  </>
                )}
              </AccordionDetails>
            </Accordion>

            {/*  Holiday Planner Configuration */}
            <Accordion
              expanded={this.state.expanded === "panelHoliday"}
              onChange={() => this.handleAccordion("panelHoliday")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panelHoliday-content"
                id="panelHoliday-header"
              >
                <Typography sx={{ width: "33%", flexShrink: 0 }}>
                  <b>Holiday Planner</b>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <HolidayPlanner
                  holidays={this.state.holidays}
                  onCreateCollection={this.handleCreateHolidayCollection}
                  onUpdateCollection={this.handleUpdateHolidayCollection}
                  onDeleteCollection={this.handleDeleteHolidayCollection}
                  onBulkUpdateCollection={this.handleBulkUpdateHolidayCollections}
                />
              </AccordionDetails>
            </Accordion>

          </Grid>
        </div>
      </div>
    );
  }
}

// Component Properties
CreateOrUpdate.propTypes = {
  settings: PropTypes.object,
  save: PropTypes.func.isRequired,
  updateSettings: PropTypes.func.isRequired,
  detail: PropTypes.func.isRequired,
  getAllCurrencies: PropTypes.func.isRequired,
  getAllPincodes: PropTypes.func.isRequired,
  getAllCountryCodes: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  upload: PropTypes.func.isRequired,
};

// Component State
function createOrEditState(state) {
  return {
    settings: state.settings,
  };
}

export default connect(createOrEditState, {
  save,
  detail,
  getAllCountryCodes,
  getAllCurrencies,
  messageShow,
  updateSettings,
  upload,
  getAllPincodes,
  createHolidayCollection,
  updateHolidayCollection,
  deleteHolidayCollection,
  getHolidayCollections,
  bulkUpdateHolidayCollections,
})(withStyles(styles)(CreateOrUpdate));
